import * as $ from "jquery";
import * as ko from "knockout";

// Models
import { BaseFontAwesomeOptions, CustomFontAwesomeOptions, ChangableIconFontAwesomeOptions, OnEventInvertChildElementIconOptions }
    from "Content/ts/Models/Shared/FontAwesome/fontAwesomeOptions";

// Services
import { FontAwesomeServices } from "Content/ts/Shared/KnockoutBindings/Services/fontAwesomeServices";

export module FontAwesomeBinding {
    ko.bindingHandlers.customIcon = {
        update: (ele: any, valueAccessor: () => string, allBindingsAccessor: () => CustomFontAwesomeOptions) => {
            const allBindings = allBindingsAccessor(),
                value = valueAccessor(),
                displayCondition = ko.unwrap(allBindings.displayCondition),
                defaultIconOverride = allBindings.defaultIconOverride || FontAwesomeServices.DefaultFontAwesomeClass;

            const iconSize = allBindings.iconSize || "",
                initialIconClasses = `${ko.unwrap(value)} ${iconSize}`;
            let element = $(ele).html(FontAwesomeServices.CustomIcon(defaultIconOverride, initialIconClasses));

            if (displayCondition != null) {
                if (displayCondition) {
                    element.show();
                } else {
                    element.hide();
                }
            }
        }
    };

    ko.bindingHandlers.changeableIcon = {
        init: (ele: any, valueAccessor: () => KnockoutComputed<string>, allBindingsAccessor: () => ChangableIconFontAwesomeOptions) => {
            let value = valueAccessor(),
                allBindings = allBindingsAccessor(),
                defaultIconOverride = allBindings.defaultIconOverride || FontAwesomeServices.DefaultFontAwesomeClass;;

            const iconSize = allBindings.iconSize || "",
                initialIconClasses = `${ko.unwrap(value)} ${iconSize}`;
            $(ele).html(FontAwesomeServices.CustomIcon(defaultIconOverride, initialIconClasses));

            if (ko.isObservable(value)) {
                value.subscribe((newValue: string) => {
                    const newIconClasses = `${newValue} ${iconSize}`;
                    $(ele).html(FontAwesomeServices.CustomIcon(defaultIconOverride, newIconClasses));
                });
            }
        }
    };

    ko.bindingHandlers.OnEventInvertChildElementIcon = {
        init: (ele: any, valueAccessor: () => null, allBindingsAccessor: () => OnEventInvertChildElementIconOptions) => {
            const allBindings = allBindingsAccessor(),
                invertableIcon = $(ele).find(".lgd-fa-invertable-icon"),
                iconType = $(invertableIcon).attr("fa-icon-type"),
                defaultIcon = $(invertableIcon).attr("fa-default-icon"),
                secondaryIcon = $(invertableIcon).attr("fa-secondary-icon");

            if (!StringHasValue(iconType) || !StringHasValue(defaultIcon) || !StringHasValue(secondaryIcon) || !StringHasValue(allBindings.EventType)) {
                // Purpose  :   Knockout seems to be swollowing part of the error. Whilst we'll have rendering issues in the UI it won't display
                //              the error message in console if done as 'throw Error()' so had to be done as a 'console.error()'
                console.error("Please ensure all required properties/attribues have been passed to the 'OnClickInvertChildElementIcon' binding");
                throw Error();
            }

            const hasClass = $(ele).hasClass(allBindings.ParentClassState),
                initialIconValue = hasClass ? defaultIcon : secondaryIcon;

            $(invertableIcon).html(FontAwesomeServices.CustomIcon(iconType, initialIconValue));

            $(ele).on(allBindings.EventType, function () {
                const hasCollapsedClass = $(this).hasClass(allBindings.ParentClassState),
                    initialIconValue = !hasCollapsedClass ? defaultIcon : secondaryIcon;

                $(invertableIcon).html(FontAwesomeServices.CustomIcon(iconType, initialIconValue));
            });
        }
    };

    ko.bindingHandlers.spinnerIcon = {
        update: (ele: any, valueAccessor: () => null, allBindingsAccessor: () => BaseFontAwesomeOptions) => {
            let allBindings = allBindingsAccessor();
            const displayCondition = ko.unwrap(allBindings.displayCondition);

            var element = $(ele).html(FontAwesomeServices.SpinnerIcon());

            if (displayCondition != null) {
                if (displayCondition) {
                    element.show();
                } else {
                    element.hide();
                }
            }
        }
    };

    ko.bindingHandlers.largeSpinnerIcon = {
        update: (ele: any, valueAccessor: () => null, allBindingsAccessor: () => BaseFontAwesomeOptions) => {
            let allBindings = allBindingsAccessor();
            const displayCondition = ko.unwrap(allBindings.displayCondition);

            var element = $(ele).html(FontAwesomeServices.LargeSpinnerIcon());

            if (displayCondition != null) {
                if (displayCondition) {
                    element.show();
                } else {
                    element.hide();
                }
            }
        }
    };

    ko.bindingHandlers.largeOverlaySpinnerIcon = {
        update: (ele: any, valueAccessor: () => null, allBindingsAccessor: () => BaseFontAwesomeOptions) => {
            let allBindings = allBindingsAccessor();
            const displayCondition = ko.unwrap(allBindings.displayCondition);

            var element = $(ele).html(FontAwesomeServices.LargeOverlaySpinnerIcon());

            if (displayCondition != null) {
                if (displayCondition) {
                    element.show();
                } else {
                    element.hide();
                }
            }
        }
    };

    function StringHasValue(value: string): boolean {
        return value != null && value != undefined && value != "";
    }
}
